import { createTheme } from '@mui/material/styles';
import { remCalc } from 'utils/remCalc';
import breakpoints from 'utils/breakpoints';
import mixins from 'utils/mixins';
import { getColor } from 'utils/colors';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const overrides = {
	'.curatedListCardSlider__section': {
		...theme.mixins.layout_styles,
		'.curatedListCardSlider__slider_wrapper': {
			'.curatedListCardSlider__slide': {
				'.curatedListCardSlider__card': {
					'a': {
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						textDecoration: 'none',
						gap: remCalc('16px'),
						[theme.breakpoints.up('md')]: {
							flexDirection: 'row',
							gap: remCalc('20px'),
						}
					},
					'.curatedListCardSlider__card_image': {
						aspectRatio: '16/9',
						display: 'block',
						height: remCalc('185.625px'),
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						backgroundRepeat: 'no-repeat',
						[theme.breakpoints.up('md')]: {
							height: remCalc('171px'),
							aspectRatio: '101/57',
						}
					},
					'.curatedListCardSlider__card_title': {
						color: getColor('ivory',700),
						fontFamily: 'var(--heading-font)',
						fontSize: remCalc('25px'),
						fontStyle: 'normal',
						fontWeight: 400,
						lineHeight: remCalc('32px'),
						letterSpacing: remCalc('-0.25px'),
						textTransform: 'capitalize',
					}
				}
			}
		}
	}
}

const styles = {};

export default styles;